<template>
    <div style="width:100%;background:rgba(240, 242, 243, 1);">
        <div style="height:50px;background:#fff;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);">
            <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight: bold;line-height: 50px;padding-left:32px;;">主叫质检</span>
            
        </div>
        <div style="padding:20px 24px 0px;">
            <div style="height:100%;background:#fff;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);padding:16px 20px;">
                <div style="color:rgba(0, 0, 0, 1);font-size:13px;;">数据提交</div>
                <a-textarea
                    v-model.trim="dataValue"
                    placeholder="说明：
                    1.最大支持50000行；
                    2.一行数据一个号码；
                    3.自动提取11位手机号码；
                    4.提交号码自动去重；
                    5.提交后不支持撤回"
                    style="margin-top:16px;height: 166px;background:rgba(121, 136, 155, 0.08)"
                />
                <div style="margin-top:16px;">
                    <span @click="submitData" style="display: inline-block;width:80px;height: 32px;line-height: 32px;text-align: center;background:rgba(24, 144, 255, 1);color:#fff;background:rgba(58, 220, 255, 1);cursor:pointer;font-size:13px">提交</span>
                </div>
            </div>
        </div>
        <div style="padding:0px 24px 30px;margin-top:16px;">
            <div style="padding:16px 20px;background:#fff;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);">
                <div style="color:rgba(0, 0, 0, 1);font-size:13px;;">话单筛选</div>
                <a-row style="margin-top:16px;">
                    <a-col :span="5">
                        <span style="color:rgba(121, 136, 155, 1);font-size:13px;">提交时间：</span>
                        <a-range-picker v-model="timeList"  style="width:240px;" format="YYYY-MM-DD" @change="dateChange" />
                    </a-col>
                    <a-col :span="5">
                        <span style="color:rgba(121, 136, 155, 1);font-size:13px;">状态：</span>
                        <a-select placeholder="请选择" v-model="status" style="border: 1px solid rgba(158, 172, 196, 0.3);width:240px;">
                            <a-select-option :value="1">
                                待质检
                            </a-select-option>
                            <a-select-option :value="2">
                                质检中
                            </a-select-option>
                            <a-select-option :value="3">
                                接通
                            </a-select-option>
                            <a-select-option :value="4">
                                未接通
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="5">
                        <span style="color:rgba(121, 136, 155, 1);font-size:13px;">商品名称：</span>
                        <a-select placeholder="请选择" v-model="good" style="border: 1px solid rgba(158, 172, 196, 0.3);width:240px;">
                            <a-select-option v-for="(item,index) in goodList" :key="index" :value="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="5" style="display: flex;">
                        <span style="color:rgba(121, 136, 155, 1);font-size:13px;float: left;margin-top:6px;">主叫号：</span>
                        <a-input v-model="callNumber" style="flex: 1;" placeholder="请输入号码（可用逗号分隔多条）" />
                    </a-col>
                    <a-col :span="4">
                        <div style="float: right;">
                            <span @click="resetCondition" style="display: inline-block;width:80px;height: 32px;line-height: 32px;text-align: center;background:#fff;color:rgba(121, 136, 155, 1);cursor:pointer;border:1px solid rgba(158, 172, 196, 0.3);margin-right: 12px;font-size:13px">重置</span>
                            <span @click="filterCallList(1)" style="display: inline-block;width:80px;height: 32px;line-height: 32px;text-align: center;background:rgba(58, 220, 255, 1);color:#fff;cursor:pointer;font-size:13px">筛选</span>
                        </div>
                    </a-col>
                </a-row>
                <div style="color:rgba(0, 0, 0, 1);font-size:13px;margin:20px 0 16px;">号码列表</div>
                <a-table :data-source="tableData" :pagination='false' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :rowKey="(record,index)=>record.id">
                    <a-table-column key="createTime" title="提交时间" data-index="createTime">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.createTime}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="callTime" title="外呼时间" data-index="callTime">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.callTime}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="commodityName" title="商品名称" data-index="commodityName">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.commodityName}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="number" title="主叫号" data-index="number">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.number}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="callee" title="被叫号" data-index="callee">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.callee}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="status" title="状态" data-index="status">
                        <template slot-scope="text, record">
                            <span style="margin-right:8px">{{record.status}}</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="id" title="操作" data-index="id">
                        <template slot-scope="text, record">
                            <span style="cursor:pointer;color:#1890FF;font-size:14px" @click="viewDel(record.id)">查看详情</span>
                        </template>
                    </a-table-column>
                </a-table>
                <div class="pagination-table">
                    <div style="float: left;">
                        <span style="display: inline-block;width:80px;height: 32px;line-height: 32px;text-align: center;background:rgba(24, 144, 255, 1);color:#fff;background:rgba(58, 220, 255, 1);cursor:pointer;margin-right:12px;font-size:13px">下载选中</span>
                        <span @click="callSplicing" style="display: inline-block;width:80px;height: 32px;line-height: 32px;text-align: center;background:rgba(24, 144, 255, 1);color:#fff;background:rgba(58, 220, 255, 1);cursor:pointer;font-size:13px">主叫拼接</span>
                    </div>
                    <a-pagination
                        show-size-changer
                        :total="total"
                        :show-total="total => `共 ${total} 条     `"
                        v-model="currentPage"
                        @change="pageChange"
                        @showSizeChange="onShowSizeChange"
                    />
                </div>
            </div>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="addNewDataModal" :closable='false' footer='' width='450px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>参数设定</span>
                    <a-icon @click="cancelAddNewData" type="close" />
                </div>
                <div class="add-data">
                    <div style="display: flex;;">
                        <span style="display: inline-block;width:100px;color:rgba(121, 136, 155, 1);font-size:13px;float: left;margin-top:6px;;">拨测被叫：</span>
                        <a-input v-model="callee" placeholder="请输入" />
                    </div>
                    <div style="display: flex;margin-top:24px;">
                        <span style="display: inline-block;width:100px;color:rgba(121, 136, 155, 1);font-size:13px;float: left;margin-top:6px;;">拨测AI通道：</span>
                        <a-input v-model="extensionCode" placeholder="请输入" />
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAddNewData">取消</a-button>
                        <a-button type="primary" @click="sureAddNewData">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="detailModal" :closable='false' footer='' width='450px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>查看详情</span>
                    <a-icon @click="cancelDel" type="close" />
                </div>
                <div class="add-data">
                    <div style="display: flex;;">
                        <span style="display: inline-block;width:110px;color:rgba(121, 136, 155, 1);font-size:13px;">主叫号：</span>
                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{callDel==null?'':callDel.number}}</span>
                    </div>
                    <div style="display: flex;margin-top:20px;">
                        <span style="display: inline-block;width:110px;color:rgba(121, 136, 155, 1);font-size:13px;">号码产权方：</span>
                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{callDel==null?'':callDel.belong}}</span>
                    </div>
                    <div style="display: flex;margin-top:20px;">
                        <span style="display: inline-block;width:110px;color:rgba(121, 136, 155, 1);font-size:13px;">后台状态：</span>
                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{callDel==null?'':callDel.status}}</span>
                    </div>
                    <div style="display: flex;margin-top:20px;">
                        <span style="display: inline-block;width:110px;color:rgba(121, 136, 155, 1);font-size:13px;">商品名称：</span>
                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{callDel==null?'':callDel.commodityName}}</span>
                    </div>
                    <div style="display: flex;margin-top:20px;">
                        <span style="display: inline-block;width:110px;color:rgba(121, 136, 155, 1);font-size:13px;">入库时间：</span>
                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{callDel==null?'':callDel.createTime}}</span>
                    </div>
                    <div style="display: flex;margin-top:20px;">
                        <span style="display: inline-block;width:110px;color:rgba(121, 136, 155, 1);font-size:13px;">历史呼叫总次数：</span>
                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{callDel==null?'':callDel.totalCallCount}}</span>
                    </div>
                    <div style="display: flex;margin-top:20px;">
                        <span style="display: inline-block;width:110px;color:rgba(121, 136, 155, 1);font-size:13px;">当前用户：</span>
                        <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{callDel==null?'':callDel.users}}</span>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDel">取消</a-button>
                        <a-button type="primary" @click="sureDel">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="callingSplicingModal" :closable='false' footer='' width='450px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>主叫拼接</span>
                    <a-icon @click="cancelCallingSplicing" type="close" />
                </div>
                <div class="add-data">
                    <div style="color:rgba(0, 0, 0, 1);font-size:13px;">
                        <span v-for="(item,index) in numberList" :key="index">
                            {{item}}
                            <span v-if="index!=numberList.length-1">,</span>
                        </span>
                    </div>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelCallingSplicing">取消</a-button>
                        <a-button type="primary" @click="sureCallingSplicing">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
    const columns = []
    const tableData = []
    export default {
        name: 'Chat',
        data() {
            return {
                dataValue: '',
                dataList: [],
                timeList: null,
                status: undefined,
                columns,
                tableData,
                selectedRowKeys: [],
                loading: false,
                total: 0,
                currentPage: 1,
                pageSize: 10,
                addNewDataModal: false,
                detailModal: false,
                callingSplicingModal: false,
                callee: '052388974406',
                extensionCode: '8000370208',
                goodList: [],
                good: undefined,
                callNumber: '',
                startTime: '',
                endTime: '',
                callDel: '',
                numberObj: {},
                numberList: [],
            }   
        },
        methods: {
            submitData() {
                if(this.dataValue!=''){
                    this.addNewDataModal = true
                    this.dataList = this.dataValue.split('\n');
                }else{
                    this.$message.error('提交内容不能为空')
                }
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys
            },
            onShowSizeChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.filterCallList(2)
            },
            pageChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.filterCallList(2)
            },
            addOperation() {
                this.addNewDataModal = true
            },
            cancelAddNewData() {
                this.addNewDataModal = false
            },
            sureAddNewData() {
                this.addNewDataModal = false
                this.axios.post('/api/numberCheck', {
                    callee: this.callee,
                    extensionCode: this.extensionCode,
                    numberList: this.dataList
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.dataList = []
                        this.dataValue = undefined
                        this.filterCallList(1)
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            cancelDel() {
                this.detailModal = false
            },
            sureDel() {
                this.detailModal = false
            },
            cancelCallingSplicing() {
                this.callingSplicingModal = false
            },
            sureCallingSplicing() {
                this.callingSplicingModal = false
            },
            callSplicing() {
                this.numberList = []
                for(let i = 0; i < this.selectedRowKeys.length; i++){
                    this.numberList.push(this.numberObj[this.selectedRowKeys[i]])
                }
                this.callingSplicingModal = true
            },
            queryGoods() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/number/manage/commodityList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.goodList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            filterCallList(type) {
                if(type == 1){
                    this.currentPage = 1
                    this.pageSize = 10
                    this.selectedRowKeys = []
                }
                this.axios(
                    {
                        method:'get',
                        url:'/api/numberCheck/list', 
                        params: {
                            commodityId: this.good,
                            timeQ: this.startTime,
                            timeZ: this.endTime,
                            status: this.status,
                            numbers: this.callNumber,
                            current: this.currentPage,
                            size: this.pageSize,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tableData = response.data.data.records
                        this.total = response.data.data.total
                        for(let i = 0; i < this.tableData.length; i++){
                            this.numberObj[this.tableData[i]['id']] = this.tableData[i]['number']
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            dateChange(date, dateString) {
                this.startTime = dateString[0]
                this.endTime = dateString[1]
            },
            viewDel(id) {
                this.detailModal = true
                this.axios(
                    {
                        method:'get',
                        url:'/api/numberCheck/detail', 
                        params: {
                            id: id,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.callDel = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            resetCondition() {
                this.good = undefined
                this.startTime = ''
                this.endTime = ''
                this.timeList = null
                this.status = undefined
                this.callNumber = undefined
                this.currentPage = 1 
                this.pageSize = 10
                this.filterCallList(1)
            }
        },
        mounted: function() {
            this.queryGoods()
            this.filterCallList(1)
        },
        beforeDestroy() {
            
        }
    }
</script>

<style scoped lang="less">
    .pagination-table{
        text-align: right;
        padding-top: 24px;
    }
    .add-new-data-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .add-data{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 24px 24px 24px;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 20px;
                margin-right: 20px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
        }
        .btn-group{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 20px 20px 0;
            height: 58px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
</style>